// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"1722371d","377":"34c5718f","458":"54287589","513":"fc926bc5","703":"1955a825","806":"6e3ee517","838":"5d5c2b24"}[chunkId] + ".chunk.js";
};